export const equipmentTypes = [
  'Components',
  'UncontrollableComponents',
  'MobileDevices',
  'Hosts',
  'Chassis',
]
